import Confirm from './Confirm'

export default Confirm



// WEBPACK FOOTER //
// ./src/components/Confirm/index.js